














































































import { Component, Vue } from "vue-property-decorator";

import Api from "@/api/cmtpl.api";
import { EventBus, BusEvents } from "@/plugins/event-bus";
import fileExt from "@/services/file.ext";

@Component
export default class CmtplDocument extends Vue {
  public isLoading: boolean = false;
  public contract: any = null;

  public contractNumber: string = "";

  private loadData(): void {
    this.isLoading = true;

    Api.getContract(this.contractNumber)
      .then((response) => {
        this.contract = response.data;
      })
      .catch((error) => EventBus.$emit(BusEvents.ERROR, error))
      .finally(() => (this.isLoading = false));;
  }

  public goBack(): void {
    this.$router.push({ name: "cmtpl" });
  }

  public print(): void {
    Api.getContractPdf(this.contractNumber)
      .then((response) => {
        const blob = fileExt.dataURItoBlob(response.data.documentPdf);
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
      })
      .catch((error) => EventBus.$emit(BusEvents.ERROR, error))
      .finally(() => (this.isLoading = false));
  }

  public created() {
    this.contractNumber = this.$route.params.contractNumber;

    this.loadData();
  }
}
